import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import VariableForm from "../../components/broadcast-system/variables/VariableForm";
import VariableListings from "../../components/broadcast-system/variables/VariableListings";
import { fetchBroadcastVariablesData } from "../../redux/ad-blog-reducers/blogSlice";

const Variables = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { broadcastVariablesLoading } = useSelector((state) => state.blog);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    selectedVariableType: "",
    selectedVariableValue: "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    type: allFilters.selectedVariableType?.value || "",
    value: allFilters.selectedVariableValue?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getVariables = (filters) => {
    dispatch(
      fetchBroadcastVariablesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getVariables(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      type: allFilters.selectedVariableType?.value || "",
      value: allFilters.selectedVariableValue?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedVariableType,
    allFilters.selectedVariableValue,
    allFilters.isActive,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Broadcast Variables">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          <div className="createNewCTOModalContainer mod-width-50p">
            {modValues.modName !== "add" && modValues.modName !== "edit" && (
              <ModalHeadAndClose
                title={modValues.modName?.replace(/_/g, " ")}
                onClose={onCloseModal}
              />
            )}

            {modValues.modName === "description" ? (
              <div className="discussionModalMessage mt30">
                <p
                  className="message"
                  dangerouslySetInnerHTML={{
                    __html: modValues.rowData?.body || "No Content Available",
                  }}></p>
              </div>
            ) : modValues.modName === "add" || modValues.modName === "edit" ? (
              <VariableForm
                isEdit={modValues.modName === "edit"}
                rowData={modValues.rowData}
                closeModal={onCloseModal}
                userInfoData={userInfoData}
                callFunction={() => getVariables(filters)}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Broadcast Variables"}
              isReload={() => getVariables(filters)}
              createBtnTxt={"+ Add New Variable"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="broadcast-variables"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={broadcastVariablesLoading}
              searchPlaceHolder="Search by variable name..."
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <VariableListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getVariables(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Variables;
